import React from 'react'
import helpLink from '../help/Account-Activation-Guide.pdf'
const AccountActivationGuide = () => <iframe src={`${helpLink}#view=fitH`} style={{width:"100%", height:"100vh"}} title='Client User Guide Account Activation' />

export default AccountActivationGuide